import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=f656fb8c&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=f656fb8c&prod&lang=scss&scoped=true"
import style1 from "./Pagination.vue?vue&type=style&index=1&id=f656fb8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f656fb8c",
  null
  
)

export default component.exports